module.exports = __webpack_public_path__ + "img/xiaoding1.prt.a8058745.jpg";